import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { traverse } from '../traverse/traverse';
var hasLinkAndCodeMarks = function hasLinkAndCodeMarks(node) {
  var _node$marks;
  var marks = (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.map(function (mark) {
    return mark.type;
  });
  return (marks === null || marks === void 0 ? void 0 : marks.includes('link')) && (marks === null || marks === void 0 ? void 0 : marks.includes('code'));
};
var removeCodeMarks = function removeCodeMarks(node) {
  if (node.marks) {
    return _objectSpread(_objectSpread({}, node), {}, {
      marks: node.marks.filter(function (mark) {
        return mark.type !== 'code';
      })
    });
  }
  return node;
};

// See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
// We declared in code mark spec that links and marks should not co-exist on
// text nodes. This util strips code marks from bad text nodes and preserves links.
export var transformTextLinkCodeMarks = function transformTextLinkCodeMarks(adf) {
  var isTransformed = false;
  var transformedAdf = traverse(adf, {
    text: function text(node) {
      if (hasLinkAndCodeMarks(node)) {
        isTransformed = true;
        return removeCodeMarks(node);
      }
    }
  });
  return {
    transformedAdf: transformedAdf,
    isTransformed: isTransformed
  };
};